import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateDateFilterWithTimezonesNotification = ({
  onUpdateClick,
  useUTC
}) => {
  return /*#__PURE__*/_jsxs(Alert, {
    "data-test-id": "fr-update-filter-notification",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.dateFilterWithTimezones.title"
    }),
    type: "tip",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.dateFilterWithTimezones.text"
      }), !useUTC && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        marginBlockStart: "250",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.dateFilterWithTimezones.warning"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "fr-update-date-filter-button",
        className: "p-left-0 p-bottom-0",
        use: "transparent",
        onClick: onUpdateClick,
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.dateFilterWithTimezones.update"
        })
      })
    })]
  });
};
export default UpdateDateFilterWithTimezonesNotification;